import React from 'react'
import PropTypes from 'prop-types'

import { mapToSelectArray } from 'Shared/helpers'
import PopupTypes from '../../../popup_types'
import {
  GlgPopup,
  GlgPopupForm,
  GlgFormInput,
  GlgSelect,
} from 'SharedComponents'

const ChangeCategoryPopupSimGolf = ({ show, data, categoriesOptions, onClose, onSave }) => {
  const handleClose = () => {
    onClose(PopupTypes.CHANGE_CATEGORY)
  }

  const handleSave = (formData) => {
    if (data) {
      onSave(data.leagueId, formData.to_category_id)
    }
  }

  const leagueName = data && data.leagueName ? data.leagueName : ''
  const currentCategoryId = data && data.categoryId ? data.categoryId : ''
  const categoriesSelectOptions = mapToSelectArray(categoriesOptions)

  return (
    <GlgPopup
      modalClass='create_clone_event_league general_sim_golf_popup'
      title={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.change_category') }
      show={ show }
      onClose={ handleClose }
      onSave={ handleSave }
      saveButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.save') }
      closeButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.cancel') }
      >
      <span className='form_content_popup_sim_golf'>
        { leagueName && (
          <h2>{ leagueName }</h2>
        )}
        <GlgPopupForm>
          <GlgFormInput
            label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.category_label') }
          >
            <GlgSelect
              name='to_category_id'
              className='container_select'
              items={ categoriesSelectOptions }
              defaultValue={ currentCategoryId }
            />
          </GlgFormInput>
        </GlgPopupForm>
      </span>
    </GlgPopup>
  )
}

ChangeCategoryPopupSimGolf.propTypes = {
  data: PropTypes.object,
  show: PropTypes.bool.isRequired,
  categoriesOptions: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default ChangeCategoryPopupSimGolf
